// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__131T2","breadcrumbItem":"Breadcrumbs_breadcrumbItem__2bl9n","breadcrumbItemLink":"Breadcrumbs_breadcrumbItemLink__1nUzK"};